import React from "react";

interface TagsProps {
  tags: string[];
  name: string;
}

export const Tags = (props: TagsProps) => {
  return (
    <div className="grid">
      <div className="col-3">
        <p>{props?.name}:</p>
      </div>
      <div className="col-9 flex gap-1 flex-wrap">
        {props.tags.map((t: string) => (
          <TagSpan tag={t} key={t} />
        ))}
      </div>
    </div>
  );
};

export const TagSpan = (props: { tag: string }) => {
  return (
    <span className="flex-inline font-semibold bg-primary border-round-md p-1">
      {props.tag}
    </span>
  );
};
